import React from "react";
import { useProfileContext } from '@/contexts/ProfileContext';
import { useUserProfileStats } from '@/hooks/analytics/useUserProfileStats';
import { EyeIcon, HeartIcon } from 'lucide-react';

const ProfileStatsCardV2: React.FC = () => {
  const { profile, isLoading: profileLoading } = useProfileContext();
  const userId = profile?.id;
  const { data: stats, isLoading: statsLoading, error } = useUserProfileStats(userId);

  if (profileLoading || !userId || statsLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading stats: {error.message}</div>;
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 w-full md:max-w-xs md:mx-auto">
      <div className="mb-4">
        <div className="text-lg font-semibold">Profile Stats</div>
        <div className="text-gray-500 text-sm">How your profile is performing</div>
      </div>
      <div className="space-y-4">
        {/* Profile Views */}
        <div className="flex items-center gap-4 p-4 rounded-lg border border-gray-100">
          <span className="bg-gray-100 rounded-full p-2">
            <EyeIcon className="h-6 w-6 text-gray-500" />
          </span>
          <div>
            <div className="text-xl font-bold text-gray-900">{stats?.total_views ?? 0}</div>
            <div className="text-gray-500 text-sm">Profile Views</div>
          </div>
        </div>
        {/* Profile Likes */}
        <div className="flex items-center gap-4 p-4 rounded-lg border border-gray-100">
          <span className="bg-gray-100 rounded-full p-2">
            <HeartIcon className="h-6 w-6 text-gray-500" />
          </span>
          <div>
            <div className="text-xl font-bold text-gray-900">{stats?.total_likes ?? 0}</div>
            <div className="text-gray-500 text-sm">Likes</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileStatsCardV2; 